import { combineReducers } from '@reduxjs/toolkit';

import formReducer from './form/slice/formSlice';
import gridReducer from './grid/slice/gridSlice';

const productoStockReducer = combineReducers({
  form: formReducer,
  grid: gridReducer,
});

export default productoStockReducer;
